// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3UrG7","productName":"Table_productName__3VWTH"};